module.exports = __webpack_public_path__ + "static/media/ic_ins_white.fd9ca03f.svg";